import { useContext, useState, useEffect, useRef } from 'react';
import { GlobalState } from "./../../../context/globalState";
import { Row, Col, Tabs } from "antd";
import ButtonComponent from "./../../../components/button/index";
import Images from "./../../../asset/exportImages";
import MDCompanyInfo from './modal/mdInfoProvider';
import { trackProductEvent } from '../../../lib/trackingService';

const DOC_TYPE_MAP = {
  1: "INSURANCE_RULES",
  2: "DISABILITY_RATE_TABLE",
  3: "APPLICATION_FORM_SAMPLE",
  4: "CERTIFICATE_SAMPLE",
  5: "SALE_KIT",
  6: "GUIDE_VIDEO",
};

const Intro = () => {
  const { isMobile, OpenLink } = useContext(GlobalState);
  const [selectTab, setSelectTab] = useState(1);
  const [openMdInfoCpn, setOpenMdInfoCpn] = useState(false);
  const startTimeRef = useRef(Date.now());

  useEffect(() => {
    startTimeRef.current = Date.now();
    return () => {
      const duration = Math.round((Date.now() - startTimeRef.current) / 1000);
      trackProductEvent("product_introduction_viewed", {
        product_id: 93,
        duration,
      });
    };
  }, []);

  const arrQuytac = [
    { id: 1, title: 'Quy tắc bảo hiểm', link: 'https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/quy-tac-bh-tai-con-nguoi.pdf' },
    { id: 2, title: 'Bảng tỷ lệ trả tiền thương tật', link: 'https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/bang-ty-le-tra-tien-thuong-tat.pdf' },
    { id: 3, title: 'Giấy yêu cầu bảo hiểm mẫu', link: 'https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/GYCBH-TNCN.doc' },
    { id: 4, title: 'Giấy chứng nhận bảo hiểm mẫu', link: 'https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/GCNBH-TNCN.docx' },
    { id: 5, title: 'Sale kit', link: 'https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/salekit.pdf' },
    { id: 6, title: 'Video hướng dẫn', link: 'https://youtu.be/7oiXiX31vR4' },
  ]

  return (
    <div>
      <div style={{ marginBottom: isMobile ? '15px' : '30px' }}>
        <img src={isMobile ? Images.BannerMB : Images.BannerDK} style={{ borderRadius: 16, width: '100%' }} />
      </div>
      <Row style={{ maxWidth: 900, margin: '0px auto' }} gutter={isMobile ? [0, 15] : [0, 30]}>
        <Col xs={24} xl={24}>
          <div style={{ overflowX: "auto" }}>
            <img
              style={{ width: "auto", whiteSpace: "nowrap", height: isMobile ? 140 : 170 }}
              src={isMobile ? Images.TaiNanGapPhaiMB : Images.TaiNanGapPhai}
              alt="Banner"
            />
          </div>
        </Col>
        <Col xs={24} xl={24}>
          <img src={isMobile ? Images.QuyenLoiMB : Images.QuyenLoi} style={{ borderRadius: 16, width: '100%' }} />
        </Col>
        <Col xs={24} xl={24}>
          <div style={{ background: '#fff', padding: 15, borderRadius: 16 }}>
            <Tabs
              centered items={[
                {
                  key: "1",
                  label: "Đối tượng tham gia"
                },
                {
                  key: "2",
                  label: "Điều khoản loại trừ"
                }
              ]}
              onTabClick={(e) => {
                setSelectTab(+e);
              }}
              tabBarStyle={{ borderBottom: '0.5px solid #646D69' }}
            />
            {
              selectTab === 1 &&
              <div style={{ display: 'grid', gap: 15 }}>
                {
                  [1, 2].map((_, index) => (
                    <div key={index + 1} style={{ display: 'flex', width: '100%', gap: 10, alignItems: 'flex-start' }}>
                      <img src={Images.ICDoiTuongThamGia} width={18} />
                      <div style={{ fontSize: 16, color: '#343A40', textAlign:'justify' }}>
                        {
                          index === 0 ?
                            "Là người Việt Nam, người nước ngoài đang công tác, học tập, cư trú hợp pháp tại Việt Nam từ 15 ngày tuổi đến 75 tuổi vào ngày bắt đầu thời hạn bảo hiểm." :
                            `Các thành viên trong hộ khẩu được xác định tại mục "thông tin cư trú" trên ứng dụng VNeID.`
                        }
                      </div>
                    </div>
                  ))
                }
              </div>
            }
            {
              selectTab === 2 &&
              <div style={{ display: 'grid', gap: 15 }}>
                {
                  [1, 2].map((_, index) => (
                    <div key={index + 1} style={{ display: 'flex', width: '100%', gap: 10, alignItems: 'flex-start' }}>
                      <img src={Images.ICLoaiTru} width={18} />
                      <div style={{ fontSize: 16, color: '#343A40', textAlign:'justify'}}>
                        {
                          index === 0 ?
                            "Người được bảo hiểm bị thương tật vĩnh viễn từ 50% trở lên." :
                            `Người được bảo hiểm bị bệnh tâm thần, phong, bệnh/hội chứng down, tự kỷ.`
                        }
                      </div>
                    </div>
                  ))
                }
              </div>
            }
          </div>
        </Col>
        <Col xs={24} xl={24}>
          <Row gutter={[15, 15]} style={{ alignItems: 'center' }}>
            <Col xs={24} xl={8} style={{ textAlign: 'center' }}>
              <img src={Images.khienBaoHiem} style={{ width: '100%', height: '100%' }} />
            </Col>
            <Col xs={24} xl={16}>
              <div style={{
                display: 'grid', gap: 15,
                // padding: isDesktop ? '15px 0px' : '' 
              }}>
                {
                  arrQuytac.map((item) => (
                    <div
                      onClick={() => {
                        trackProductEvent("product_document_viewed", {
                          product_id: 93,
                          doc_type: DOC_TYPE_MAP[item.id] || item.title,
                        });
                        OpenLink(item.link);
                      }}
                      key={item.id}
                      style={{ background: '#fff', borderRadius: 100, padding: '7px 10px', display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}
                    >
                      <div style={{ display: 'flex', width: '100%', gap: 10 }}>
                        <img src={Images.ICQuyTac} width={18} />
                        <div style={{ fontSize: 15, color: '#343A40' }}>
                          {item.title}
                        </div>
                      </div>
                      <img src={Images.ICDropdow} width={20} height={20} style={{ marginRight: -5, rotate: '270deg' }} />
                    </div>
                  ))
                }
                <div
                  onClick={() => {
                    trackProductEvent("product_document_viewed", {
                      product_id: 93,
                      doc_type: "PROVIDER_INFO",
                    });
                    setOpenMdInfoCpn(true);
                  }}
                  key={6}
                  style={{ background: '#fff', borderRadius: 100, padding: '7px 10px', display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}
                >
                  <div style={{ display: 'flex', width: '100%', gap: 10 }}>
                    <img src={Images.ICQuyTac} width={18} />
                    <div style={{ fontSize: 15, color: '#343A40' }}>
                      Thông tin công ty bảo hiểm
                    </div>
                  </div>
                  <img src={Images.ICDropdow} width={20} height={20} style={{ marginRight: -5, rotate: '270deg' }} />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={24} xl={24}>
          <img src={isMobile ? Images.QuyTrinhBoiThuongMB : Images.QuyTrinhBoiThuong} style={{ borderRadius: 16, width: '100%' }} />
        </Col>
      </Row>
      <ButtonComponent />
      <MDCompanyInfo open={openMdInfoCpn} handleCancel={()=>{setOpenMdInfoCpn(false)}} isMobile={isMobile} />
      <style jsx>{`
      .ant-tabs-nav-list { display: flex; width: 100%;}
      .ant-tabs-tab { flex: 1; justify-content: center; text-align: center; }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #009B4B !important;
    font-weight: 500;
  }
        .ant-tabs-ink-bar { background: #009B4B !important; }
        .custom-table {
          border-collapse: collapse;
          width: 100%;
        }
        .ant-tabs-nav {
          margin-bottom: 15px !important
        }
      `}</style>
    </div>
  );
}

export default Intro;